/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateContainerInput = {
    clientMutationId?: string | null;
    slug: string;
    profileImageSlug?: string | null;
    containerNumber: string;
    voyageSlug: string;
    containerType: string;
    containerSize?: string | null;
    procedure?: string | null;
    atb?: string | null;
    bookingNumber?: string | null;
    turninLocationSlug?: string | null;
    pickupLocationSlug?: string | null;
    pickupReference?: string | null;
    turninReference?: string | null;
    pickupComment?: string | null;
    billOfLadingNumber?: string | null;
    terminalDate?: string | null;
    dischargeDate?: string | null;
    latestPickupDate?: string | null;
    pickupDate?: string | null;
    latestTurninDate?: string | null;
    thcPaidDate?: string | null;
    linkedContacts: Array<LinkedContactInput>;
    shippingLineSlug: string;
};
export type LinkedContactInput = {
    role: string;
    contactSlug: string;
};
export type AddContainerLinkedContactsMutationVariables = {
    input: infoUpdateContainerInput;
};
export type AddContainerLinkedContactsMutationResponse = {
    readonly infoUpdateContainer: {
        readonly container: {
            readonly slug: string;
        };
    } | null;
};
export type AddContainerLinkedContactsMutation = {
    readonly response: AddContainerLinkedContactsMutationResponse;
    readonly variables: AddContainerLinkedContactsMutationVariables;
};



/*
mutation AddContainerLinkedContactsMutation(
  $input: infoUpdateContainerInput!
) {
  infoUpdateContainer(input: $input) {
    container {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddContainerLinkedContactsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateContainerPayload",
        "kind": "LinkedField",
        "name": "infoUpdateContainer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Container",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddContainerLinkedContactsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateContainerPayload",
        "kind": "LinkedField",
        "name": "infoUpdateContainer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Container",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c576af8ae2e215a461f0a68ecfc305ab",
    "id": null,
    "metadata": {},
    "name": "AddContainerLinkedContactsMutation",
    "operationKind": "mutation",
    "text": "mutation AddContainerLinkedContactsMutation(\n  $input: infoUpdateContainerInput!\n) {\n  infoUpdateContainer(input: $input) {\n    container {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '41f1307ce5fe8568afe055bd64db2995';
export default node;
